import { ApiError } from "@/lib/api-client";

/** Below this the message is ours; at or above it, it is a stack trace's worth of nothing. */
const SERVER_ERROR_STATUS = 500;

/**
 * Shows the API's own words for a refused action.
 *
 * The generic `getUserFacingApiMessage` is right for customer-facing screens,
 * where backend text could leak internals to someone who should not see them.
 * Here the reader is an operator and the messages are written for them —
 * "someone else saved first", "the mailing list is empty" — and replacing those
 * with "something went wrong" would delete the only instruction they need.
 * Server faults and network failures still fall back, since their text is for us.
 */
export function changelogErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.status > 0 && error.status < SERVER_ERROR_STATUS) {
    return error.message;
  }
  return fallback;
}
